var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from '@doordash/component-fields';
import { Text, Spacing, Colors, BorderRadius, StackChildren, Stack, } from '@doordash/design-language';
var InputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n  border: 1px solid\n    ", ";\n  border-radius: ", "px;\n"], ["\n  padding: ", "px;\n  border: 1px solid\n    ",
    ";\n  border-radius: ", "px;\n"])), Spacing.XxSmall, function (props) {
    return props.hasError ? Colors.TextError : Colors.BorderSecondary;
}, BorderRadius.Small);
var FieldError = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), Spacing.XxxSmall);
/**
 * By using VGS, app does not interact with the payment fields at all.
 * This component is used to design the input display for the VGS payment fields.
 */
export var PaymentInputField = function (_a) {
    var labelName = _a.labelName, description = _a.description, error = _a.error, children = _a.children;
    return (React.createElement(Text, { tag: "label", styles: Text.Styles.FieldLargeLabel },
        React.createElement(StackChildren, { size: Stack.Sizes.XxxxSmall },
            React.createElement(Text, { styles: Text.Styles.FieldLargeLabel }, labelName),
            description && (React.createElement(Text, { styles: Text.Styles.Body1, color: Text.Colors.TextSecondary, children: description })),
            React.createElement(InputContainer, { hasError: !!error }, children),
            error && (React.createElement(FieldError, null,
                React.createElement(ErrorMessage, { error: error }))))));
};
var templateObject_1, templateObject_2;
